import React, { useEffect } from "react";
import OpenAIBotInterviewRoom from "./OpenAIBotInterviewRoom";
import axios from "axios";

const { REACT_APP_CLOUD_FUNCTIONS_URL } = process.env;

const BotInterviewRoom = () => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [apiKey, setApiKey] = React.useState("");

  useEffect(() => {
    axios
      .get(REACT_APP_CLOUD_FUNCTIONS_URL + "/get_km_meta")
      .then((response) => {
        setApiKey(response.data?.km_meta);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching API key:", error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return <OpenAIBotInterviewRoom apiKey={apiKey} />;
};

export default BotInterviewRoom;
